'use strict';

module.exports = {
    /**
     * @function
     * @description This function will check if the cartmerged param exists in the url and remove it
     */
    init: function () {
        // code that will check url if param cartmerged exists and remove it from url
        var url = new URL(window.location.href);
        var cartmerged = url.searchParams.get('cartmerged');
        if (cartmerged) {
            url.searchParams.delete('cartmerged');
            window.history.replaceState({}, document.title, url);
        }
    }
};
